module.exports = {"school-name":"Idaho State University","logo":"/sites/idaho-state/logo.png","logout-color":"#626262","logout-font-color":"#fff","header-color":"#000","header-border-color":"#F47920","footer-color":"#000","footer-info":"© 2020 Idaho State University | The Write Class™ | © 2020 Boise State University","help-button-color":"#626262","help-button-font-color":"#FFFFFF"}


//////////////////
// WEBPACK FOOTER
// ./sites/idaho-state/site-config.json
// module id = 116
// module chunks = 12